<template>
    <div>
      <common-list
        ref="list"
        url="WeighingPart/GetList"
        @currentrow="handlerCurrentRow"
      >
        <!-- 条件区域 -->
        <template v-slot:filter="{ filter }">
          <el-col :span="6">
          <el-form-item label="配件名称" prop="PartName">
            <el-input
              v-model.trim="filter.PartName"
              placeholder="配件名称" 
              clearable
            ></el-input>
          </el-form-item>
        </el-col>
        </template>
        <!-- 按钮区域 -->
        <template v-slot:option>
          <el-button
            type="primary"
            icon="el-icon-plus"
            @click="add"
            v-if="auth('WeighingAdd')"
            >添加</el-button
          >
          <el-button
            type="warning"
            icon="el-icon-edit"
            @click="edit"
            v-if="auth('WeighingEdit')"
            >编辑</el-button
          >
          <el-button
            type="danger"
            icon="el-icon-delete"
            @click="deleteItem"
            v-if="auth('WeighingDelete')"
            >删除</el-button
          >
          <el-button 
            type="blue" 
            icon="el-icon-tickets" 
            @click="show"
            v-if="auth('WeighingShow')"
            >查看</el-button
          >
        </template>
        <!-- 展示区域 -->
        <template v-slot:body>
          <el-table-column
            label="配件编号"
            prop="PartNumber"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="配件名称"
            prop="PartName"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column
            label="数量"
            prop="PartNum"
            show-overflow-tooltip
          ></el-table-column>
          <el-table-column label="重量(KG)" 
            prop="Weight" 
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="司磅员" 
            prop="Weigher" 
            show-overflow-tooltip>
          </el-table-column>
          <el-table-column label="称重日期" 
            prop="WeightingTime" 
            show-overflow-tooltip>
          </el-table-column>
        </template>
      </common-list>
      <!-- 弹窗区域 Show -->
      <div>
        <AddEdit :item="itemAddEdit" @success="getData"></AddEdit>
        <Showdialog :item="itemShow"></Showdialog>
      </div>
    </div>
  </template>
  
  <script>
  import AddEdit from "./AddEdit";
  import Showdialog from "./Show";
  export default {
    components: {
        AddEdit,
        Showdialog
    },
    data() {
      return {
        itemAddEdit: {},
        itemShow:{},
        showitem: [],
      };
    },
    computed: {

    },
    mounted() {
     
    },
    methods: {
      getData() {
        this.$refs.list.getTableData();
      },
      add() {
        this.itemAddEdit = {};
      },
      edit() {
        if (!this.hasCurrentRow()) {
          return;
        }
        this.itemAddEdit = { KeyId: this.currentrow.KeyId };
      },
      deleteItem() {
        if (!this.hasCurrentRow()) {
          return;
        }
        this.$confirm(
          `将删除配件名称为【${this.currentrow.PartName}】的配件称重信息, 是否继续?`,
          "提示信息",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            cancelButtonClass: "el-button--canale",
            type: "warning",
          }
        )
          .then(() => {
            this.$delete("WeighingPart/Delete", {
              KeyId: this.currentrow.KeyId,
            }).then(() => {
              this.$message.success("删除成功");
              this.$refs.list.getTableData();
            });
          })
          .catch(() => {});
      },
      show() {
        if (!this.hasCurrentRow()) {
          return;
        }
        this.itemShow = { KeyId: this.currentrow.KeyId };
       
      },
    },
  };
  </script>
  
  <style>
  </style>